import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";

import { ApiGatewayApi } from "api";
import { CredentialsProvider } from "auth/modules/sagas/CredentialsProvider";
import { CREATE_CMS_TOKEN, CreateCMSTokenAction, createCMSTokenEnd } from "../actions/CreateCMSToken";

export function* createCMSToken(action: CreateCMSTokenAction) {
    const { appId, credentials } = action.payload;

    try {
        const api = new ApiGatewayApi(new CredentialsProvider(credentials));
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.createCMSToken(appId);
        yield put(createCMSTokenEnd(appId, undefined, result.token));
    } catch (e) {
        yield put(createCMSTokenEnd(appId, e, undefined));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchCreateCMSToken() {
    yield takeEvery(CREATE_CMS_TOKEN, createCMSToken);
}
